import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="19"
      fill="none"
      viewBox="0 0 23 19"
    >
      <path fill="#fff" d="M11.5 0l10.825 18.75H.675L11.5 0z"></path>
    </svg>
  );
}

export default Icon;
